import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "swiper/css";
import { Dialog } from "@mui/material";
import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Matt from "Images/profile/mattRd.png";
import Mary from "Images/profile/maryRd.png";
import Advice from "./images/advice.svg";
import Review from "./images/review.svg";
import Routine from "./images/routine.svg";
import Arrow from "./images/arrow.svg";
import styles from "./styles.module.scss";
import H2Font from "Root/profile/components/common/H2Font";
import H3Font from "Root/profile/components/common/H3Font";
import H4Font from "Root/profile/components/common/H4Font";
import RegFont from "Root/profile/components/common/RegFont";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
const icons = [
    {
        title: "Review your nutrition",
        text: "Provide suggestions on your diet and eating habits",
        icon: Review,
    },
    {
        title: "Offer personalized advice",
        text: "To help you get the most out of your protein",
        icon: Advice,
    },
    {
        title: "Recommend lifestyle improvements",
        text: "Tailored to your goals",
        icon: Routine,
    },
];
const rdData = [
    {
        name: "Matt Mazzino",
        title: "Registered Dietitian",
        img: Matt,
        bio: `Matt Mazzino is a Registered Dietitian who has worked with a wide range of patients, clients, and athletes in an acute care hospital, a physical rehabilitation hospital, and outpatient counseling settings. Matt has earned his pro card as a competitive bodybuilder, and his passion for nutrition and fitness led him to become a dietitian.

    In his free time, Matt enjoys working out, playing video games, reading, spending time with family and fueling up with oatmeal, fruit, and omelets.`,
    },
    {
        name: "Mary Albus",
        title: "Registered Dietitian",
        img: Mary,
        bio: `Mary Albus is a Registered Dietitian from Penn State University with experience helping people meet their nutritional needs in both community and clinical settings. Mary is passionate about taking a personalized approach with clients so they’re confident and empowered to set and crush goals.

    She has been a fitness instructor (Zumba and indoor cycling) for 10+ years and loves pizza, edamame, mango, and chocolate chip cookies.`,
    },
];
const PersonalizedByHumans = () => {
    const [modalOpened, setModalOpened] = useState(false);
    const [activeSlide, setActiveSlide] = useState("");
    const showDialog = (active) => {
        setActiveSlide(active);
        setModalOpened(true);
    };
    const onClose = () => {
        setActiveSlide("");
        setModalOpened(false);
    };
    const swiperRef = useRef(null);
    const onSwiper = (swiper) => {
        swiperRef.current = swiper;
    };
    const changeSlide = (isNext) => {
        if (swiperRef.current) {
            if (isNext) {
                swiperRef.current.slideNext();
            }
            else {
                swiperRef.current.slidePrev();
            }
        }
    };
    const modalData = rdData.find((item) => item.name === activeSlide);
    return (_jsx("div", { className: styles.page, children: _jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.text, children: [_jsx(H2Font, { fontWeight: 400, children: "Personalized Health By Humans, Not Bots" }), _jsx(RegFont, { children: "We know navigating a health journey can be overwhelming. Every Gainful subscription includes free, 1-on-1 access to a Registered Dietitian, who can:" }), _jsx("div", { className: styles.icons, children: icons.map((item) => (_jsxs("div", { className: styles.icon, children: [_jsx("img", { src: item.icon, alt: item.title }), _jsxs("div", { className: styles.icon_text, children: [_jsx(RegFont, { fontWeight: 400, children: item.title }), _jsx(RegFont, { children: item.text })] })] }, item.title))) })] }), _jsxs("div", { className: styles.carousel_wrapper, children: [_jsxs(Swiper, { className: styles.scroller, spaceBetween: 50, slidesPerView: 1, scrollbar: {
                                hide: true,
                            }, loop: true, pagination: {
                                clickable: true,
                            }, onSwiper: onSwiper, children: [rdData.map((item) => (_jsxs(SwiperSlide, { className: styles.slide, children: [_jsx("img", { className: styles.image, src: item.img, alt: item.name }), _jsx(H4Font, { fontWeight: 400, children: item.name }), _jsx(RegFont, { children: item.title }), _jsx(UnderlinedButton, { label: "Read Full Bio", onClick: () => showDialog(item.name) })] }, item.name))), _jsxs("div", { className: styles.arrows, children: [_jsx("button", { type: "button", onClick: () => changeSlide(false), className: styles.prev, children: _jsx("img", { src: Arrow, alt: "left arrow" }) }), _jsx("button", { type: "button", className: styles.next, onClick: () => changeSlide(true), children: _jsx("img", { src: Arrow, alt: "right arrow" }) })] })] }), _jsxs(Dialog, { classes: {
                                paper: styles.modal_root,
                            }, open: modalOpened, onClose: onClose, children: [modalData ? (_jsxs("div", { className: styles.modal, children: [_jsx("div", { className: styles.images, children: _jsx("img", { className: styles.main_image, src: modalData?.img, alt: modalData.name }) }), _jsxs("div", { className: styles.text, children: [_jsx("div", { className: styles.name, children: _jsx(H3Font, { children: modalData.name }) }), _jsx(RegFont, { children: modalData.title }), _jsx(RegFont, { children: modalData.bio })] })] })) : (_jsx("p", {})), _jsx("button", { onClick: onClose, className: styles.x_mark, children: _jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "1.20711", y1: "1.29289", x2: "15.2071", y2: "15.2929", stroke: "#333333", strokeWidth: "2" }), _jsx("line", { x1: "0.792893", y1: "15.2929", x2: "14.7929", y2: "1.29289", stroke: "#333333", strokeWidth: "2" })] }) })] })] })] }) }));
};
export default PersonalizedByHumans;
